// extracted by mini-css-extract-plugin
export default {"offeringItem":"FilterOfferingList_offeringItem__zG37Y","padding":"FilterOfferingList_padding__hp5P9","smallDevicePadding":"FilterOfferingList_smallDevicePadding__AMClG"};